import "../src/style";
import Embed from "../src/components/embed";
import { render } from "preact";

render(<Embed />, document.getElementById("constructor-container"));
